// Packages
import { useState, useEffect } from "react";
import moment from "moment";
import { Link, withRouter, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { map, size } from "lodash";
// Assets
import backArrow from "../../assets/images/backArrow.png";
import settingIcon from "../../assets/images/settingIcon.png";
import editIcon from "../../assets/images/editIcon.png";
import schoolLogo from "../../assets/images/default_school.png";
import vdoIcon from "../../assets/images/vdoIcon.png";
import imgIcon from "../../assets/images/imgIcon.png";
import otherIcon from "../../assets/images/otherIcon.png";
import documentIcon from "../../assets/images/documentIcon.png";
import Delete from "../../assets/images/Delete.png";
import Toolbar from "@material-ui/core/Toolbar";

// Materials Ui
import { Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Animation } from "@devexpress/dx-react-chart";
import Popover from "@material-ui/core/Popover";
import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";

// Services
import userService from "../../services/user.service";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import { CircularProgress } from "@material-ui/core";

// Styles
import "../superAdmin/superAdmin.css";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const data = [
  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },

  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },

  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },

  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },

  {
    INVOICEID: "R1000000000001",
    DATETIME: "2020-01-01 | 12:05 PM",
    PAYMENTMETHOD: "California",
    STATUS: "+44-8927471190",
    AMOUNT: "Active",
  },
];
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const chartdata = [
  {
    storageType: "free",
    area: 12,
  },
  {
    storageType: "occupied",
    area: 7,
  },
];

const columns = [
  {
    title: "id",
    field: "id",
    hidden: true,
  },
  // {title:"INVOICE ID",field:"INVOICEID"},
  {
    title: "FIRST NAME",
    field: "firstName",
  },
  {
    title: "DATE / TIME",
    field: "createdAt",
    type: "date",
    format: "dd/MM/yyyy : hh:mm",
  },
  {
    title: "LAST NAME",
    field: "lastName",
  },
  {
    title: "EMAIL",
    field: "email",
  },
  {
    title: "POSITION PLAYED",
    field: "positionPlayed",
  },
  {
    title: "PHONE NO.",
    field: "phoneNumber",
  },
  {
    title: "GROUP",
    field: "groupName",
  },
  {
    title: "GRAD YEAR",
    field: "graduationYear",
  },
  {
    render: () => (
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
      >
        <MoreVertIcon />
      </IconButton>
    ),
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

function TeamDetails() {
  const classes = useStyles();
  const params = useParams();
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState(0);
  const [schoolData, setSchoolData] = useState([]);
  const [atheleteDataShow, setAtheleteDataShow] = useState([]);
  const [coachesDataShow, setCoachesDataShow] = useState([]);
  const [teamsId] = useState(params.teamId);
  const [atheleteCount, setAthleteCount] = useState(0);
  const [coachCount, setCouchCount] = useState(0);
  const [imageLogo, setImageLogo] = useState(null);

  const teamone = document.getElementById("Team");
  if (teamone) {
    teamone.classList.add("btnActive");
  }

  useEffect(() => {
    userService
      .getTeamsDetails(teamsId)
      .then((response) => {
        let arr = [];
        arr.push(response.data.data);
        setSchoolData(arr);
        if (response.data.data.teamAthelets != []) {
          setAthleteCount(response.data.data.teamAthelets.length);
          setAtheleteDataShow(response.data.data.teamAthelets);
        }
        if (response.data.data.teamCoaches != []) {
          setCouchCount(response.data.data.teamCoaches.length);
          setCoachesDataShow(response.data.data.teamCoaches);
        }
        if (response.data.data.uploadedLogo != null) {
          let imageFilepath = response.data.data.uploadedLogo.filePath;
          setImageLogo(imageFilepath);
        } else {
          let imageFilepath = null;
          setImageLogo(imageFilepath);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, [teamsId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <SchoolAdminDashboard />
      <div className="content-layout p-0">
        <Toolbar className="tb-p">
          <div className="mng-add-header stickyy mg-bottom-0">
            <div>
              <p>
                <Link to="/schoolteams">
                  <span className="fs-22 black semi-bold header-nm">TEAMS</span>
                </Link>{" "}
                <img src={backArrow} alt="back" />
                {size(schoolData) > 0 &&
                  map(schoolData, (item, index) => (
                    <span
                      key={index}
                      className="fs-22 black  semi-bold header-nm"
                    >
                      {item.teamName}
                    </span>
                  ))}
              </p>
            </div>

            <div>
              {size(schoolData) > 0 &&
                map(schoolData, (item, index) => (
                  <Link to={`/editteams/${item.id}`}>
                    {" "}
                    <img
                      src={editIcon}
                      className="ed-icn cp icon-hover"
                      alt=" "
                    />{" "}
                  </Link>
                ))}
              <img
                className="cp icon-hover"
                onClick={handleClick}
                src={settingIcon}
                alt=" "
              />
            </div>
          </div>
        </Toolbar>

        <div className="mng-add-header mg-bottom-0 mg-top-0 header-height">
          <div>
            {imageLogo && (
              <div>
                <img
                  className="details-profile img-fluid mg-right"
                  src={imageLogo}
                  alt="PIC"
                />

                {size(schoolData) > 0 &&
                  map(schoolData, (item, index) => (
                    <label key={index} className="fs-30 bold athlete-nm">
                      {item.teamName}
                    </label>
                  ))}
              </div>
            )}

            {!imageLogo && (
              <div>
                <img
                  className="details-profile img-fluid mg-right-10"
                  src={schoolLogo}
                  alt="PIC"
                />

                {size(schoolData) > 0 &&
                  map(schoolData, (item, index) => (
                    <label key={index} className="fs-30 bold athlete-nm">
                      {item.teamName}
                    </label>
                  ))}
              </div>
            )}
          </div>

          <div
            className="dflex"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="mg-right-10" id="hoverCard">
              {/* <Link to="/SuperAdminCoaches" style={{ color:'black' }}> */}
              <div className="txt-center">
                <div className="number-card border-grey">
                  {/* {schoolData &&
                      schoolData.map((item, index) => ( */}
                  <label className="fs-30 bold pd-0">{coachCount}</label>
                  {/* ))} */}
                  <p className="fs-16 semi-bold">Coaches</p>
                </div>
              </div>
              {/* </Link> */}
            </div>

            <div id="hoverCard">
              <div className="txt-center">
                <div className="number-card border-grey">
                  <label className="fs-30 bold">{atheleteCount}</label>
                  <p className="fs-16 semi-bold">Athletes</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div>
            <div className="row">
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Typography className={classes.typography}>
                  <label className="bold brd-bottom">Team Settings</label>
                  <div className="small-popup-menuu1-container">
                    <div className="small-popup-menuu1">
                      <img src={Delete} alt="share"></img>
                      <p className="manage-small-popup-menuu1-p">Delete Team</p>
                    </div>
                  </div>
                </Typography>
              </Popover>
            </div>
          </div>
          <div className={classes.root} id="tabs">
            <AppBar position="static" color="default">
              <Tabs
                className="txt-blue bold bgwhite p-0"
                value={value}
                onChange={handleChange}
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="INFO." {...a11yProps(0)} />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              {schoolData &&
                schoolData.map((item, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-lg-6 col-md-12 white-card oflow"
                  >
                    <div className="clear10"></div>
                    <div className="row ">
                      <div className="col-4 fmlabel">
                        <label>Created Date</label>
                      </div>
                      <div className="col-8">
                        <p>{moment(item.createdAt).format("MM/DD/YYYY")}</p>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-4 fmlabel">
                        <label>Team Name</label>
                      </div>
                      <div className="col-8">
                        <p>{item.teamName}</p>
                      </div>
                    </div>
                  </div>
                ))}
              <div className="clear20"></div>
              <div className="col-12 col-sm-12 col-lg-6 col-md-12 white-card oflow">
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-4 fmlabel">
                    <label className="semi-bold fs-16">Coaches</label>
                    <div className="clear10"></div>
                  </div>
                  <div className="col-8">
                    {coachesDataShow &&
                      coachesDataShow.map((item, index) => (
                        <p key={index}>{item.name}</p>
                      ))}
                  </div>
                </div>
              </div>
              <div className="clear20"></div>
              <div className="col-12 col-sm-12 col-lg-6 col-md-12 white-card oflow">
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-4 fmlabel">
                    <label className="semi-bold fs-16">Athletes</label>
                    <div className="clear10"></div>
                  </div>
                  <div className="col-8">
                    {atheleteDataShow &&
                      atheleteDataShow.map((item, index) => (
                        <p key={index}>{item.name}</p>
                      ))}
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div
                className="col-12 col-sm-12 col-md-12 col-lg-12"
                id="paymentTable"
              >
                <MaterialTable
                  className="bold"
                  title=""
                  data={data}
                  columns={columns}
                  options={{
                    filtering: true,
                    selection: true,
                    headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                    rowStyle: { fontSize: 15, fontFamily: "Rajdhani-Medium" },
                  }}
                ></MaterialTable>
              </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <div>
                <div className="row">
                  <div className="col-6 rightBorder-grey">
                    <div className="row">
                      <div className="col-8" id="chartstyle">
                        <Chart data={chartdata}>
                          <PieSeries
                            valueField="area"
                            argumentField="storageType"
                          />
                          <Animation />
                        </Chart>
                        <p className="txt-center txt-blue semi-bold">
                          301 GB used of 1024 GB Used
                        </p>
                      </div>
                      <div className="col-4">
                        <label>Storage Overview</label>
                        <div className="row">
                          <div className="col-2 ">
                            <div className="freeStorage"></div>
                          </div>
                          <div className="col-8 txtlightgrey">
                            <label>Free</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-2">
                            <div className="occupiedStorage"></div>
                          </div>
                          <div className="col-8 txtlightgrey">
                            <label>Occupied</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16 txt-blue">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-6">
                            <label>Last Upgraded On :</label>
                          </div>
                          <div className="col-6 p-0">
                            <p>22/03/2021</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <p>Upgrade Storage</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={vdoIcon} alt=" " />
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Videos</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">200GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={imgIcon} alt=" " />
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Images</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">500GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={documentIcon} alt=" " />
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Doucments/Notes</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">1GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={otherIcon} alt=" " />
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Others</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">50GB</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(TeamDetails);
